export const PROJECT_TYPES = [
  { value: 'app', label: 'App', icon: 'ri-apps-2-line' },
  { value: 'business', label: 'Business', icon: 'ri-store-2-line' },
  { value: 'api', label: 'API', icon: 'ri-server-line' },
  { value: 'video', label: 'Video', icon: 'ri-video-line' },
  { value: 'document', label: 'Document', icon: 'ri-file-text-line' },
  { value: 'agent', label: 'Agent', icon: 'ri-robot-line' },
  { value: 'workflow', label: 'Workflow', icon: 'ri-flow-chart' },
  { value: 'other', label: 'Other', icon: 'ri-shape-line' },
];

export function typeMeta(value: string) {
  return PROJECT_TYPES.find((t) => t.value === value) ?? PROJECT_TYPES[PROJECT_TYPES.length - 1];
}
